"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tuple = function tuple() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args;
}; // `Object.keys` does not return the keys as string literals, only strings. Use this helper as a
// workaround. https://github.com/Microsoft/TypeScript/pull/12253#issuecomment-263132208


var keys = function keys(obj) {
  return Object.keys(obj);
}; // `Object.entries` is ES2017, but this lib only supports ES2015 at runtime, so we must define our
// own version.


var entries = function entries(obj) {
  return keys(obj).map(function (key) {
    return tuple(key, obj[key]);
  });
};

var fromEntries = function fromEntries(arr) {
  // `Object.assign` is poorly typed: it returns `any` when spreading. Use cast to workaround.
  return Object.assign.apply(Object, [{}].concat(arr.map(function (_a) {
    var k = _a[0],
        v = _a[1];

    var _b;

    return _b = {}, _b[k] = v, _b;
  })));
}; // Inspired by https://stackoverflow.com/a/37616104/5932012


exports.pickBy = function (obj, predicate) {
  return fromEntries(entries(obj).filter(function (entry) {
    var key = entry[0],
        value = entry[1];
    return predicate(key, value);
  }));
};